import globalStyles from '../globals.module.css';

const LoadingAlt = () => {
    return (
        <div className={globalStyles.loadingContainerAlternate}>
            <div className={globalStyles.spinner}></div>
            <p>Loading...</p>
        </div>
    );
};

export default LoadingAlt;